(function($, visceral) {

    if(visceral == null) {
        window.visceral = visceral = {}; 
    }


    $(function () {
        init();
    });
    
    
    function init() {
        $('.team-popup').each(function() {
            let grid_item = $(this).closest('.vc_grid-item').addClass('vc_grid-item__team-popup');
            grid_item.click(function (event) {
                event.preventDefault();
                var data = gather_person_data(grid_item)
                let popup = show_person(data, grid_item);
                register_clickoff_handler(popup);
            });
            grid_item.find('.vc_gitem-post-data-source-post_title a').click(function(event) { 
                event.preventDefault(); 
            });
        });
    }

    function scroll_to(element) {
        let offset = $('header.header').height() + 125;
        $("html, body").animate({ scrollTop: element.offset().top - offset }, 300);
    }

    function is_descendant(ancestor, descendant) {
        let set = descendant.parents();
        for(var i = 0; i < set.length; i++) {
            if($(set[i]).is(ancestor)) {
                return true;
            }
            return false;
        }
    }
    
    function register_clickoff_handler(element) {
        //timeout to wait until after current click event has run its course before wiring up the new click event
        setTimeout(function() {
            var handler = function(event) {
                let event_src = $(event.srcElement);
                if(event_src.is(element) || is_descendant(element, event_src)) {
                    //user clicked inside the team popup. ignore and let occur normally
                }
                else {
                    //user clicked outside team-popup. dismiss it
                    element.addClass('team-popup__container--closed')
                    setTimeout(function() { element.remove(); }, 500);
                    $('body').unbind('click', handler)
                }
            }
            $('body').on('click', handler);
        });

    }
    
    function show_person(person, parent) {
        console.log('show person', person);
        let actual_parent = parent.closest('.vc_pageable-slide-wrapper');
        
        var outer = $('<div class="team-popup__container"></div>')
            .addClass('team-popup__container--closed')
            .css('top', parent.position().top)
            .prependTo(actual_parent);

        var inner = $('<div class="team-popup__container__inner"></div>').appendTo(outer);

        inner
            .append(`<h4 class="team-popup__name">${person.name}</h4>`)
            .append(`<div class="team-popup__title">${person.title}</div>`)
            .append(`<div class="team-popup__body">${person.body}</div>`)
            .append(social);
        
        if(person.email) {
            inner.append(`<div class="team-popup__email"><a href="mailto:${person.email}">Contact ${person.first_name}</a></div>`)
        }

        let has_social = false;
            
        var social = $('<div class="team-popup__social"></div>')
            .append(`<label>Follow ${person.first_name}</label>`);

        if(person.facebook) {
            social.append(`<a href="${person.facebook}" class="team-popup__social__link svgicon-facebook-after"></a>`)
            has_social = true;
        }

        if(person.twitter) {
            social.append(`<a href="${person.twitter}" class="team-popup__social__link svgicon-twitter-after"></a>`)
            has_social = true;
        }

        if(person.linkedin) {
            social.append(`<a href="${person.linkedin}" class="team-popup__social__link svgicon-linkedin-after"></a>`)
            has_social = true;
        }
        
        if(has_social) {
            social.appendTo(inner)
        }
        
        setTimeout(function() { outer.removeClass('team-popup__container--closed') });
        scroll_to(outer);
        return outer;
    }
    
    function gather_person_data(item) {
        let data = {
            name: item.find('.vc_gitem-post-data-source-post_title').text(),
            title: item.find('.field_5d2fab253a4ba').text(),
            body: item.find('.vc_gitem-post-data-source-content').text(),
            facebook: item.find('.field_5d2fab4c3a4bb').text(),
            twitter: item.find('.field_5d2fab563a4bc').text(),
            linkedin: item.find('.field_5d2fab5d3a4bd').text(),
        }
        data.email = item.find('.field_5d63f1eceb847').text();
        data.first_name = /^(.*?)\s/.exec(data.name)[1];
        return data;
    }


})(jQuery, window.visceral);


// WEBPACK FOOTER //
// ./scripts/ajax-popup.js